const EDIT_APP_MEET_WE_INFO_DRAFT_PREFIX = 'admin:appMeetWeInfoDraft:edit:'
export const NEW_APP_MEET_WE_INFO_DRAFT_KEY = 'admin:appMeetWeInfoDraft:new'
export const APP_MEET_WE_INFO_IMAGE_FILE_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,image/png,image/gif,image/jpeg,image/webp'
export const APP_MEET_WE_INFO_IMAGE_FILE_ERROR_MESSAGE = '이미지 파일만 업로드할 수 있습니다.'

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeTextValue = (value, fallbackValue = '') => {
    if (value === undefined || value === null) {
        return fallbackValue
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue = 0) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

// 우리끼리대회 안내 이미지 업로드에서 허용하는 파일 형식만 통과시킨다.
export const isAppMeetWeInfoImageFile = (file) => {
    return Boolean(file) && (
        (file.type && file.type.startsWith('image/')) ||
        /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name || '')
    )
}

// 현재 활성된 우리끼리대회 안내 폼은 대륙/국가/대회종류만 sessionStorage에 남긴다.
export const createAppMeetWeInfoDraftPayload = ({ params = {} } = {}) => {
    return {
        params: {
            continents: normalizeTextValue(params.continents, 'asia'),
            cCode: normalizeTextValue(params.cCode),
            category: normalizeNumberValue(params.category, 0),
        }
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 국가 선택 흐름을 이어간다.
export const applyAppMeetWeInfoDraft = ({ baseParams = {}, draft }) => {
    const normalizedBaseDraft = createAppMeetWeInfoDraftPayload({
        params: baseParams,
    })

    if (!draft) {
        return {
            params: {
                ...baseParams,
                ...normalizedBaseDraft.params,
            },
        }
    }

    const draftParams = draft.params || {}

    return {
        params: {
            ...baseParams,
            continents: draftParams.continents === undefined
                ? normalizedBaseDraft.params.continents
                : normalizeTextValue(draftParams.continents, normalizedBaseDraft.params.continents),
            cCode: draftParams.cCode === undefined
                ? normalizedBaseDraft.params.cCode
                : normalizeTextValue(draftParams.cCode, normalizedBaseDraft.params.cCode),
            category: draftParams.category === undefined
                ? normalizedBaseDraft.params.category
                : normalizeNumberValue(draftParams.category, normalizedBaseDraft.params.category),
        }
    }
}

export const createEditAppMeetWeInfoDraftKey = (meetWeInfoId) => `${EDIT_APP_MEET_WE_INFO_DRAFT_PREFIX}${meetWeInfoId}`

export const readAppMeetWeInfoDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppMeetWeInfoDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 선택 흐름은 그대로 유지한다.
    }
}

export const clearAppMeetWeInfoDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
